import React, { FunctionComponent } from 'react';
import { Button } from 'react-design-components';
import { TFunction } from 'i18next';

interface Props {
  onClick?: () => void;
  t: TFunction;
  type?: 'submit' | 'button';
  translationKey?: string;
  disabled?: boolean;
}

const NextButton: FunctionComponent<Props> = ({
  onClick,
  t,
  type = 'button',
  translationKey = 'next',
  disabled = false,
}) => {
  return (
    <Button onClick={onClick} type={type} disabled={disabled}>
      {t(translationKey)}
    </Button>
  );
};

export default NextButton;
